
import PadletLogo, { LogoType } from 'vuecomponents/PadletLogo.vue'
import SurfaceTitleMobile from 'vuecomponents/SurfaceTitleMobile.vue'
import AppBarAccountAvatar from 'vuecomponents/AppBarAccountAvatar.vue'
import OzIconButton from 'library/v4/components/OzIconButton.vue'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Getter, Action, namespace } from 'vuex-class'
import type { User } from 'types'

@Component({
  components: {
    OzIconButton,
    PadletLogo,
    AppBarAccountAvatar,
    SurfaceTitleMobile,
  },
})
export default class SurfaceHeaderMobile extends Vue {
  $el!: HTMLDivElement

  @State isEmbedded!: boolean
  $refs!: { surfaceTitle: SurfaceTitleMobile; surfaceNavbar: HTMLDivElement }
  @State isElectronApp!: boolean
  @State xHeader!: boolean
  @State user!: User
  @State isTouchable!: boolean
  @Getter headerHeight!: number
  @Getter dir!: 'ltr' | 'rtl'
  @Getter backgroundColor!: string
  @Getter headerColor!: string
  @Getter backgroundLuminance!: 'light' | 'dark'
  @Getter colorScheme!: 'light' | 'dark'
  @Getter isMap!: boolean
  @Getter amIRegistered!: boolean
  @Getter homeUrl!: string
  @Getter isTitleBarTransparent!: boolean
  @Getter canIAdminister!: boolean
  @Action resizeHeader!: (props: { height: number }) => void
  @Action checkAndSubscribeToPushNotifications!: () => void
  @namespace('settings').Action toggleSettingsPanel!: () => void

  get logoType(): LogoType {
    if (this.isMap) {
      return this.colorScheme === 'light' ? LogoType.Dark300 : LogoType.Light300
    }
    return this.backgroundLuminance === 'light' ? LogoType.Dark300 : LogoType.Light300
  }

  get realBackgroundLuminance(): 'light' | 'dark' {
    if (this.isMap) {
      return this.colorScheme
    }
    return this.backgroundLuminance
  }

  mounted(): void {
    // Don't prompt for notifications if the user is not registered and the app is not the electron app
    if (this.amIRegistered && !this.isElectronApp) this.checkAndSubscribeToPushNotifications()
    this.updateHeaderHeight()
  }

  updateHeaderHeight(): void {
    if (!this.isCollapsed) {
      this.$nextTick(() => {
        this.resizeHeader({ height: this.$refs.surfaceNavbar.offsetHeight + this.$refs.surfaceTitle.$el.clientHeight })
      })
    } else {
      this.resizeHeader({ height: 48 })
    }
  }

  isCollapsed: boolean | null = null

  collapse(): void {
    this.isCollapsed = true
    this.updateHeaderHeight()
  }

  toggleIsCollapsed(): void {
    this.isCollapsed = !this.isCollapsed
    this.updateHeaderHeight()
  }
}
